module.exports = __webpack_public_path__ + "media/images/success/appstore_short-9493e9c375a13248fd4290ee3f7577aa.png";